
<style scopped>
#local-video-canvas > div {
  border-radius: 8px !important;
  display: flex;
  align-items: center;
  justify-items: center;
  background-color: black;
}

#local-video-canvas {
  display: flex;
  align-items: center;
  justify-items: center;
  animation: all 1s;
  background-color: black;
}

.inverted {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  transition: transform 0.8s;
}

#remote-video-canvas {
  border-radius: 8px !important;
}

.perit-offline:not(.action-button) {
  -webkit-filter: blur(5px); /* Safari 6.0 - 9.0 */
  filter: blur(5px) brightness(50%);
}

.waiting-call-container {
  padding: 10px;
  width: 100%;
}

.waiting-call {
  align-items: center;
  background: none !important;
  margin-top: 0;
}

.video-btn-group {
  z-index: 12;
  width: 100%;
  height: 100px;
  position: fixed;
  bottom: 0;
  background: transparent;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.remote-video {
  width: 120px;
  height: 120px;
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 99;
}

#participant_video_call {
  display: flex;
  align-items: center;
  justify-items: center;
}

.video-body {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: none;
  display: flex;
  justify-items: center;
}

.close-call-button {
}

.close-call-container {
  position: fixed;
  bottom: 90px;
  left: auto;
  text-align: center;
  width: 100%;
}

.slide-fade-enter-active {
  transition: all 0.1s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>
<template>
  <v-app id="participant_video_call">
    <v-main v-if="!termsAccepted">
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center" no-gutters>
          <v-col style="max-width: 800px">
            <v-img src="@/assets/logo.png" width="320px" class="mx-auto mb-8"></v-img>
            <v-card>
              <v-card-title>{{ $capitalize($tc("model.video_call_terms_of_acceptance")) }}</v-card-title>
              <v-textarea class="mx-4" :value="term_of_agreement" readonly filled />
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="acceptTerms">
                  {{ $capitalize($tc("model.video_call_agree_and_continue")) }}
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-main v-show="termsAccepted">
      <div class="video-header">
        <div v-show="callAnswered" id="remote-video-canvas" class="remote-video black"></div>
      </div>
      <div class="video-body" @click="toggleInterface">
        <div v-if="!callAnswered" class="waiting-call-container">
          <v-card class="waiting-call" flat>
            <v-card-text class="text-center">
              <v-avatar size="120" style="opacity: 1">
                <v-icon size="110" color="white">mdi-clock</v-icon>
              </v-avatar>
              <h2 class="white--text font-weight-thin mt-2" style="opacity: 1">{{ $capitalize($tc("model.video_call_awaiting_analysis")) }}</h2>
            </v-card-text>
          </v-card>
        </div>
        <transition name="slide-fade">
          <div class="close-call-container" v-if="showInterface">
            <v-btn @click="leaveCall" class="mx-2 close-call-button" fab dark color="red">
              <v-icon dark>mdi-phone-hangup</v-icon>
            </v-btn>
          </div>
        </transition>
      </div>
      <div
        id="local-video-canvas"
        class="fill-height black"
        :class="{ 'perit-offline': !callAnswered, 'inverted': !cameraSwitched }"
      ></div>
      <transition name="slide-fade">
        <div class="video-btn-group" v-if="showInterface">
          <v-btn @click="toggleCameraSwitch()" class="mx-2 action-button" icon>
            <v-icon color="white">mdi-camera-retake</v-icon>
          </v-btn>
          <v-btn @click="toggleVideoCamera()" class="mx-2 action-button" icon :value="camera_off">
            <v-icon color="white">{{ camera_off ? 'mdi-video' : 'mdi-video-off' }}</v-icon>
          </v-btn>
          <v-btn @click="toggleMute()" class="mx-2 action-button" icon>
            <v-icon color="white">{{ mic_off ? 'mdi-microphone' : 'mdi-microphone-off' }}</v-icon>
          </v-btn>
        </div>
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import { joinCall, leaveCall, switchCamera, toggleVideo, toggleMicrophone } from "../services/agora";
import { term_of_agreement } from "../services/remote_analysis";

export default {
  name: "participant-video-call",
  data: () => ({
    term_of_agreement,
    openCall: false,
    callAnswered: false,
    termsAccepted: false,
    cameraSwitched: false,
    remote_video_canvas_container: null,
    local_video_canvas_container: null,
    remoteUser: {
      uid: null,
      playerContainer: null,
      callHasBeenAnswered: () => ({}),
      callHasBeenLeft: () => ({}),
    },
    localUser: {
      uid: null,
      playerContainer: null,
      tokenHasBeenExpired: () => ({}),
    },
    showInterface: true,
    muted: false,
    camera_off: false,
    mic_off: false,
  }),
  methods: {
    toggleInterface() {
      this.showInterface = !this.showInterface;
    },
    async toggleCameraSwitch() {
      if (await switchCamera()) {
        this.cameraSwitched = !!!this.cameraSwitched
      }
    },
    async toggleVideoCamera() {
      await toggleVideo();
      this.camera_off = !!!this.camera_off;
    },
    async toggleMute() {
      await toggleMicrophone();
      this.mic_off = !!!this.mic_off;
    },
    acceptTerms() {
      this.remoteUser.callHasBeenAnswered = this.callHasBeenAnswered;
      this.remoteUser.callHasBeenLeft = this.callHasBeenLeft;
      this.localUser.tokenHasBeenExpired = this.leaveCall;

      if (this.$route.query.token && this.$route.query.channel) {
        this.termsAccepted = true;
        this.openCall = true;

        joinCall(
          this.$route.query.channel,
          this.$route.query.token,
          this.localUser,
          this.remoteUser
        );
      } else {
        this.$store.commit("sendMessage", {
          text: "Você não pode acessar este conteúdo",
          color: "red",
        });
      }
    },
    async callHasBeenAnswered() {
      this.callAnswered = true;
    },
    async callHasBeenLeft() {
      await this.leaveCall();
      this.$store.commit("sendMessage", {
        text: "Participante deixou a chamada",
        color: "orange",
      });
      this.$store.commit("setVideoCall", {
        ...this.videoCall,
        isActive: false,
      });
    },
    async leaveCall() {
      await leaveCall();
      this.$store.commit("setVideoCall", {
        ...this.videoCall,
        isActive: false,
      });
      this.$router.replace({ name: "video_call_ended" });
    },
  },
  mounted() {
    this.remoteUser.playerContainer = document.querySelector(
      "#remote-video-canvas"
    );
    this.localUser.playerContainer = document.querySelector(
      "#local-video-canvas"
    );
  },
};
</script>
